import { render, staticRenderFns } from "./JourneyBadge.vue?vue&type=template&id=22356097"
import script from "./JourneyBadge.vue?vue&type=script&lang=js"
export * from "./JourneyBadge.vue?vue&type=script&lang=js"
import style0 from "./JourneyBadge.vue?vue&type=style&index=0&id=22356097&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports